import React, { useState, useEffect } from 'react';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { crearViaje, actualizarViaje, eliminarViaje as eliminarViaje_DB, crearHito, eliminarHito as eliminarHitoDB, actualizarHito, crearGasto, eliminarGasto as eliminarGastoDB, getCarriers, getClientes, getUsuarios, getRutas, normalizar, getLogoBase64, getPlantillas } from '../lib/db'; // eslint-disable-line

const ahora = new Date();
const hace20hrs = new Date(ahora - 20 * 60 * 60 * 1000).toISOString();
const fechaHoy = ahora.toLocaleDateString('es-MX', { weekday: 'short', day: '2-digit', month: '2-digit', year: '2-digit' });

const viajesDefault = [];

const hitosDefault = ['Llegada a carga', 'En tránsito', 'Descanso', 'Detenida', 'Llegada a descarga', 'Completado', 'En espera de determinaciones'];
const estadoViaje = { active: '#00e5a0', completed: '#3b82f6' };
const labelViaje = { active: 'Activo', completed: 'Completado' };
const categoriasGasto = ['Combustible', 'Casetas', 'Comida', 'Mecanico', 'Hospedaje', 'Otro'];

function estadoUnidadDesdeHitos(hitos, hitosConfig) {
  if (!hitos || hitos.length === 0) return { label: 'Sin iniciar', color: '#6b7280' };
  const ultimo = hitos[hitos.length - 1].nombre;
  const config = hitosConfig?.find(h => h.nombre === ultimo);
  if (config?.color) return { label: ultimo, color: config.color };
  if (ultimo === 'Llegada a carga') return { label: 'Llegada a carga', color: '#8b5cf6' };
  if (ultimo === 'En movimiento') return { label: 'En movimiento', color: '#00e5a0' };
  if (ultimo === 'En tránsito') return { label: 'En tránsito', color: '#00e5a0' };
  if (ultimo === 'Descanso') return { label: 'Descanso', color: '#3b82f6' };
  if (ultimo === 'Detenida') return { label: 'Detenida', color: '#ef4444' };
  if (ultimo === 'Llegada a descarga') return { label: 'Llegada a descarga', color: '#f59e0b' };
  if (ultimo === 'Completado') return { label: 'Completado', color: '#00e5a0' };
  if (ultimo === 'En espera de determinaciones') return { label: 'En espera', color: '#f59e0b' };
  return { label: ultimo, color: '#6b7280' };
}

function calcularTiempoEspera(hitos) {
  if (!hitos || hitos.length === 0) return null;
  const parse = (h) => {
    if (!h || !h.hora) return null;
    const p = h.hora.split(':').map(Number);
    if (p.length < 2 || isNaN(p[0]) || isNaN(p[1])) return null;
    const d = new Date(); d.setHours(p[0], p[1], 0, 0); return d;
  };
  const t1 = parse(hitos.find(h => h.nombre === 'Llegada a carga'));
  const t2 = parse(hitos.find(h => h.nombre === 'En movimiento'));
  const t3 = parse(hitos.find(h => h.nombre === 'Llegada a descarga'));
  const t4 = parse(hitos.find(h => h.nombre === 'Completado'));
  const resultados = [];
  if (t1 && t2 && t2 > t1) {
    const mins = Math.round((t2 - t1) / 60000);
    resultados.push({ label: 'Espera en carga', valor: mins < 60 ? `${mins} min` : `${(mins / 60).toFixed(1)} hrs` });
  }
  if (t3 && t4 && t4 > t3) {
    const mins = Math.round((t4 - t3) / 60000);
    resultados.push({ label: 'Espera en descarga', valor: mins < 60 ? `${mins} min` : `${(mins / 60).toFixed(1)} hrs` });
  }
  return resultados.length > 0 ? resultados : null;
}

function esReciente(v) {
  return v.estado === 'active';
}

export default function Viajes({ viajes: viajesProp, setViajes: setViajesProp, viajePreseleccionado, setViajePreseleccionado, hitosConfig, empresaId, empresa }) {
  const [viajes, setViajesLocal] = useState(viajesProp || viajesDefault);
  const [selected, setSelected] = useState(null);
  const [showNuevo, setShowNuevo] = useState(false);
  const [editando, setEditando] = useState(false);
  const [activeTab, setActiveTab] = useState('bitacora');
  const [showConfirmDelete, setShowConfirmDelete] = useState(false);
  const [filtro, setFiltro] = useState('');
  const [errorNumero, setErrorNumero] = useState('');
  const [nuevoViaje, setNuevoViaje] = useState({
    numero: '', factura: '', carrier: '', conductor: '', ruta: '', cliente: '',
    salida: '', linkGps: '', caja: '', placas: '', unidad: '', gps: '', kmRecorridos: '',
    notas: '', usuario_id: '', usuario_nombre: '',
    direccion_origen: '', direccion_destino: '',
    contacto_origen: '', contacto_destino: '',
    descripcion_mercancia: '', peso_mercancia: '', instrucciones_especiales: ''
  });
  const [editData, setEditData] = useState(null);
  const [nuevoGasto, setNuevoGasto] = useState({ descripcion: '', monto: '', categoria: 'Combustible', comentario: '' });
  const [showNuevoGasto, setShowNuevoGasto] = useState(false);
  const [nuevoHito, setNuevoHito] = useState('');
  const [showNuevoHito, setShowNuevoHito] = useState(false);
  const [hitoPendiente, setHitoPendiente] = useState(null);
  const [showAprobacion, setShowAprobacion] = useState(false);
  const [listaCarriers, setListaCarriers] = useState([]);
  const [listaClientes, setListaClientes] = useState([]);
  const [listaUsuarios, setListaUsuarios] = useState([]);
  const [editandoHito, setEditandoHito] = useState(null);
  const [editHitoData, setEditHitoData] = useState({});
  const [listaRutas, setListaRutas] = useState([]);
  const [hitoUbicacion, setHitoUbicacion] = useState('');
  const [hitoEta, setHitoEta] = useState('');
  const [ultimoHitoWA, setUltimoHitoWA] = useState(null);
  const [plantillas, setPlantillas] = useState([]);

  useEffect(() => {
    const cargar = async () => {
      if (!empresaId) return;
      const { data: carriers } = await getCarriers(empresaId);
      const { data: clientes } = await getClientes(empresaId);
      const { data: usuarios } = await getUsuarios(empresaId);
      if (carriers) setListaCarriers(carriers.filter(c => c.activo));
      if (clientes) setListaClientes(clientes.filter(c => c.activo));
      if (usuarios) setListaUsuarios(usuarios);
      const { data: rutasDB } = await getRutas(empresaId);
      if (rutasDB) setListaRutas(rutasDB);
      const { data: plantillasDB } = await getPlantillas(empresaId);
      if (plantillasDB) setPlantillas(plantillasDB);
    };
    cargar();
  }, [empresaId]); // eslint-disable-line

  useEffect(() => {
    if (viajePreseleccionado) {
      setSelected({ ...viajePreseleccionado, hitos: viajePreseleccionado.hitos || [], gastos: viajePreseleccionado.gastos || [] });
      setShowNuevo(false); setEditando(false); setActiveTab('bitacora');
      if (setViajePreseleccionado) setViajePreseleccionado(null);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [viajePreseleccionado]);

  const setViajes = (val) => { setViajesLocal(val); if (setViajesProp) setViajesProp(val); };

  const viajesFiltrados = viajes.filter(esReciente).filter(v =>
    !filtro ||
    normalizar(v.carrier).includes(normalizar(filtro)) ||
    normalizar(v.ruta).includes(normalizar(filtro)) ||
    normalizar(v.unidad).includes(normalizar(filtro)) ||
    normalizar(v.conductor).includes(normalizar(filtro)) ||
    normalizar(v.numero).includes(normalizar(filtro)) ||
    normalizar(v.cliente).includes(normalizar(filtro))
  );

  const handleCrearViaje = async () => {
    setErrorNumero('');
    if (!nuevoViaje.numero) { setErrorNumero('El numero de viaje es obligatorio.'); return; }
    const existe = viajes.some(v => v.numero?.toLowerCase().trim() === nuevoViaje.numero.toLowerCase().trim());
    if (existe) { setErrorNumero(`El numero "${nuevoViaje.numero}" ya existe.`); return; }
    const usuarioSeleccionado = listaUsuarios.find(u => u.id === nuevoViaje.usuario_id);
    const viajeData = {
      empresa_id: empresaId, numero: nuevoViaje.numero, factura: nuevoViaje.factura || null,
      carrier: nuevoViaje.carrier || null, conductor: nuevoViaje.conductor || null,
      ruta: nuevoViaje.ruta || null, cliente: nuevoViaje.cliente || null,
      caja: nuevoViaje.caja || null, placas: nuevoViaje.placas || null,
      unidad: nuevoViaje.unidad || null, gps: nuevoViaje.gps || null,
      link_gps: nuevoViaje.linkGps || null,
      km_recorridos: nuevoViaje.kmRecorridos ? parseFloat(nuevoViaje.kmRecorridos) : null,
      usuario_id: nuevoViaje.usuario_id || null,
      usuario_nombre: usuarioSeleccionado ? usuarioSeleccionado.nombre : null,
      estado: 'active',
      direccion_origen: nuevoViaje.direccion_origen || null,
      direccion_destino: nuevoViaje.direccion_destino || null,
      contacto_origen: nuevoViaje.contacto_origen || null,
      contacto_destino: nuevoViaje.contacto_destino || null,
      descripcion_mercancia: nuevoViaje.descripcion_mercancia || null,
      peso_mercancia: nuevoViaje.peso_mercancia || null,
      instrucciones_especiales: nuevoViaje.instrucciones_especiales || null,
    };
    const { data, error } = await crearViaje(viajeData);
    if (!error && data) { const v = { ...data, hitos: [], gastos: [] }; setViajes([...viajes, v]); }
    setShowNuevo(false);
    setNuevoViaje({
      numero: '', factura: '', carrier: '', conductor: '', ruta: '', cliente: '',
      salida: '', linkGps: '', caja: '', placas: '', unidad: '', gps: '', kmRecorridos: '',
      notas: '', usuario_id: '', usuario_nombre: '',
      direccion_origen: '', direccion_destino: '',
      contacto_origen: '', contacto_destino: '',
      descripcion_mercancia: '', peso_mercancia: '', instrucciones_especiales: ''
    });
  };

  const handleEliminarViaje = async () => {
    await eliminarViaje_DB(selected.id);
    setViajes(viajes.filter(v => v.id !== selected.id));
    setSelected(null); setShowConfirmDelete(false);
  };

  const guardarEdicion = async () => {
    if (editData.numero !== selected.numero) {
      const existe = viajes.some(v => v.id !== selected.id && v.numero?.toLowerCase().trim() === editData.numero?.toLowerCase().trim());
      if (existe) { alert(`El numero "${editData.numero}" ya existe en otro viaje.`); return; }
    }
    const usuarioSeleccionado = listaUsuarios.find(u => u.id === editData.usuario_id);
    const cambios = {
      numero: editData.numero, factura: editData.factura || null, carrier: editData.carrier || null,
      conductor: editData.conductor || null, ruta: editData.ruta || null, cliente: editData.cliente || null,
      caja: editData.caja || null, placas: editData.placas || null, unidad: editData.unidad || null,
      gps: editData.gps || null, link_gps: editData.linkGps || null,
      km_recorridos: editData.kmRecorridos ? parseFloat(editData.kmRecorridos) : null,
      usuario_id: editData.usuario_id || null,
      usuario_nombre: usuarioSeleccionado ? usuarioSeleccionado.nombre : (editData.usuario_nombre || null),
      estado: editData.estado || selected.estado,
      direccion_origen: editData.direccion_origen || null,
      direccion_destino: editData.direccion_destino || null,
      contacto_origen: editData.contacto_origen || null,
      contacto_destino: editData.contacto_destino || null,
      descripcion_mercancia: editData.descripcion_mercancia || null,
      peso_mercancia: editData.peso_mercancia || null,
      instrucciones_especiales: editData.instrucciones_especiales || null,
    };
    await actualizarViaje(selected.id, cambios);
    const updated = viajes.map(v => v.id === selected.id ? { ...v, ...editData } : v);
    setViajes(updated); setSelected({ ...selected, ...editData }); setEditando(false);
  };

  const agregarGasto = async () => {
    if (!nuevoGasto.descripcion || !nuevoGasto.monto) return;
    const gastoData = {
      viaje_id: selected.id, descripcion: nuevoGasto.descripcion, monto: parseFloat(nuevoGasto.monto),
      categoria: nuevoGasto.categoria, comentario: nuevoGasto.comentario || null,
      fecha: new Date().toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' }),
    };
    const { data } = await crearGasto(gastoData);
    const gasto = data || { ...gastoData, id: Date.now() };
    const updated = viajes.map(v => v.id === selected.id ? { ...v, gastos: [...v.gastos, gasto] } : v);
    setViajes(updated); setSelected({ ...selected, gastos: [...selected.gastos, gasto] });
    setNuevoGasto({ descripcion: '', monto: '', categoria: 'Combustible', comentario: '' }); setShowNuevoGasto(false);
  };

  const eliminarGasto = async (gastoId) => {
    await eliminarGastoDB(gastoId);
    const updated = viajes.map(v => v.id === selected.id ? { ...v, gastos: v.gastos.filter(g => g.id !== gastoId) } : v);
    setViajes(updated); setSelected({ ...selected, gastos: selected.gastos.filter(g => g.id !== gastoId) });
  };

  const agregarHito = async () => {
    if (!nuevoHito) return;
    const hitoConfig = hitosConfig ? hitosConfig.find(h => h.nombre === nuevoHito) : null;
    const esCompletado = selected.estado === 'completed';
    const esManual = !esCompletado && hitoConfig ? hitoConfig.aprobacion === 'manual' : false;
    const now = new Date();
    const hitoData = {
      viaje_id: selected.id, nombre: nuevoHito,
      hora: now.toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' }),
      fecha: now.toLocaleDateString('es-MX', { weekday: 'short', day: '2-digit', month: '2-digit', year: '2-digit' }),
      ubicacion: hitoUbicacion || '', eta: hitoEta || '', comentario: '', aprobado: true, notificado: false
    };
    const tieneGPS = selected.linkGps || selected.link_gps;
    if (esManual && !tieneGPS) {
      // Sin GPS: registrar directamente sin pedir aprobacion
      const { data } = await crearHito({ ...hitoData, aprobado: false, notificado: false });
      const hito = data || hitoData;
      let nuevoEstado = selected.estado;
      if (nuevoHito === 'Completado') { nuevoEstado = 'completed'; await actualizarViaje(selected.id, { estado: 'completed', fecha_cierre: new Date().toISOString() }); }
      const updated = viajes.map(v => v.id === selected.id ? { ...v, hitos: [...v.hitos, hito], estado: nuevoEstado } : v);
      setViajes(updated); setSelected({ ...selected, hitos: [...selected.hitos, hito], estado: nuevoEstado });
      setNuevoHito(''); setShowNuevoHito(false); setHitoUbicacion(''); setHitoEta('');
      return;
    }
    if (!esManual) {
      const { data } = await crearHito(hitoData);
      const hito = data || hitoData;
      let nuevoEstado = selected.estado;
      if (nuevoHito === 'Completado' && !esCompletado) {
        nuevoEstado = 'completed';
        await actualizarViaje(selected.id, { estado: 'completed', fecha_cierre: new Date().toISOString() });
      }
      const updated = viajes.map(v => v.id === selected.id ? { ...v, hitos: [...v.hitos, hito], estado: nuevoEstado } : v);
      setViajes(updated); setSelected({ ...selected, hitos: [...selected.hitos, hito], estado: nuevoEstado });
    } else {
      setHitoPendiente({ hito: hitoData, viaje: selected, hitoConfig }); setShowAprobacion(true);
    }
    const clienteWA = listaClientes.find(c => c.nombre === selected.cliente);
    const plantillaWA = plantillas.find(p => p.descripcion === nuevoHito);
    if (plantillaWA && clienteWA?.whatsapp) {
      setUltimoHitoWA({ plantilla: plantillaWA, cliente: clienteWA, ubicacion: hitoUbicacion, eta: hitoEta, nombre: nuevoHito });
    } else {
      setUltimoHitoWA(null);
    }
    setNuevoHito(''); setShowNuevoHito(false); setHitoUbicacion(''); setHitoEta('');
  };

  const guardarEdicionHito = async (idx) => {
    const hito = selected.hitos[idx];
    const cambios = { hora: editHitoData.hora || hito.hora, fecha: editHitoData.fecha || hito.fecha, ubicacion: editHitoData.ubicacion ?? hito.ubicacion, comentario: editHitoData.comentario ?? hito.comentario };
    if (hito.id) await actualizarHito(hito.id, cambios);
    const hitos = selected.hitos.map((h, i) => i === idx ? { ...h, ...cambios } : h);
    const updated = viajes.map(v => v.id === selected.id ? { ...v, hitos } : v);
    setViajes(updated); setSelected({ ...selected, hitos });
    setEditandoHito(null); setEditHitoData({});
  };

  const eliminarHito = async (idx) => {
    const hito = selected.hitos[idx];
    if (hito.id) await eliminarHitoDB(hito.id);
    const hitos = selected.hitos.filter((_, i) => i !== idx);
    const updated = viajes.map(v => v.id === selected.id ? { ...v, hitos } : v);
    setViajes(updated); setSelected({ ...selected, hitos });
  };

const exportarViajePDF = async () => {
    const doc = new jsPDF({ format: 'letter' });
    const v = selected;
    const pageW = 215.9;
    const margin = 18;
    let y = 14;

    // Encabezado: fecha izquierda, logo derecha, misma altura, ambos arriba de la línea
    const fechaStr = new Date().toLocaleDateString('es-MX', { day: '2-digit', month: 'long', year: 'numeric' });

    if (empresa?.logo_url) {
      try {
        const base64 = await getLogoBase64(empresa.logo_url);
        if (base64) {
          const img = new Image();
          await new Promise(res => { img.onload = res; img.src = base64; });
          const logoW = 40;
          const logoH = logoW * (img.naturalHeight / img.naturalWidth);
          const canvasLogo = document.createElement('canvas');
          canvasLogo.width = img.naturalWidth;
          canvasLogo.height = img.naturalHeight;
          canvasLogo.getContext('2d').drawImage(img, 0, 0);
          doc.addImage(canvasLogo.toDataURL('image/png'), 'PNG', pageW - margin - logoW, y - 7, logoW, logoH);
        }
        doc.setFontSize(9); doc.setFont('helvetica', 'normal'); doc.setTextColor(120, 120, 120);
        doc.setFontSize(9); doc.setFont('helvetica', 'normal'); doc.setTextColor(120, 120, 120);
        y = 26; 
      } catch {
        doc.setFontSize(9); doc.setFont('helvetica', 'normal'); doc.setTextColor(120, 120, 120);
        doc.text(fechaStr, margin, 14);
        y = 22;
      }
    } else {
      doc.setFontSize(9); doc.setFont('helvetica', 'normal'); doc.setTextColor(120, 120, 120);
      doc.text(fechaStr, margin, 14);
      doc.setFontSize(11); doc.setFont('helvetica', 'bold'); doc.setTextColor(0, 0, 0);
      doc.text(empresa?.nombre || 'LogiConnect', pageW - margin - 50, 14);
      y = 22;
    }

    // Titulo
    doc.setFontSize(16); doc.setFont('helvetica', 'bold'); doc.setTextColor(0, 0, 0);
    doc.text('CARTA DE INSTRUCCIONES', margin, y); y += 6;
    doc.setFontSize(9); doc.setFont('helvetica', 'normal'); doc.setTextColor(100, 100, 100);
    doc.text(`Viaje: ${v.numero}  ·  ${fechaStr}`, margin, y); y += 12;

    // Instrucciones especiales
    if (v.instrucciones_especiales) {
      doc.setFillColor(245, 245, 245);
      const instrLines = doc.splitTextToSize(v.instrucciones_especiales, pageW - margin * 2 - 8);
      const instrH = 16 + instrLines.length * 5;
      doc.roundedRect(margin, y, pageW - margin * 2, instrH, 2, 2, 'F');
      doc.setFontSize(8); doc.setFont('helvetica', 'bold'); doc.setTextColor(0, 0, 0);
      doc.text('INSTRUCCIONES ESPECIALES', margin + 5, y + 7);
      doc.setFont('helvetica', 'normal'); doc.setTextColor(40, 40, 40); doc.setFontSize(9);
      doc.text(instrLines, margin + 5, y + 13);
      y += instrH + 10;
    }

    // Origen y destino lado a lado
    const colW = (pageW - margin * 2 - 10) / 2;

    const parsearRuta = (ruta, lado) => {
      if (!ruta) return '';
      const sep = ruta.includes('\u2192') ? '\u2192' : '->';
      const partes = ruta.split(sep);
      return lado === 'origen' ? partes[0]?.trim() : partes[1]?.trim();
    };

    const drawBloque = (titulo, lugar, direccion, x, startY) => {
      let sy = startY;
      doc.setFontSize(9); doc.setFont('helvetica', 'bold'); doc.setTextColor(0, 0, 0);
      doc.text(titulo, x, sy); sy += 4;
      doc.setLineWidth(0.3); doc.setDrawColor(150, 150, 150);
      doc.line(x, sy, x + colW, sy); sy += 6;
      if (lugar) {
        doc.setFontSize(11); doc.setFont('helvetica', 'bold'); doc.setTextColor(0, 0, 0);
        doc.text(lugar, x, sy); sy += 6;
      }
      if (direccion) {
        doc.setFontSize(8); doc.setFont('helvetica', 'normal'); doc.setTextColor(80, 80, 80);
        const lines = doc.splitTextToSize(direccion, colW - 2);
        doc.text(lines, x, sy); sy += lines.length * 4 + 4;
      }
      return sy;
    };

    const parsearLugar = (parte) => {
      if (!parte) return { lugar: '', direccion: '' };
      const idx = parte.indexOf(' · ');
      if (idx === -1) return { lugar: parte.trim(), direccion: '' };
      return { lugar: parte.substring(0, idx).trim(), direccion: parte.substring(idx + 3).trim() };
    };

    const origenStr = v.ruta?.split('\u2192')[0] || v.ruta?.split('->')[0] || '';
    const destinoStr = v.ruta?.split('\u2192')[1] || v.ruta?.split('->')[1] || '';
    const origen = parsearLugar(origenStr);
    const destino = parsearLugar(destinoStr);

    const yOrigen = drawBloque('ORIGEN', origen.lugar, origen.direccion || v.direccion_origen, margin, y);
    const yDestino = drawBloque('DESTINO', destino.lugar, destino.direccion || v.direccion_destino, margin + colW + 10, y);
    y = Math.max(yOrigen, yDestino) + 12;

    // Mercancia
    const mercDatos = [
      v.descripcion_mercancia ? ['Descripcion', v.descripcion_mercancia] : null,
      v.peso_mercancia ? ['Peso / Volumen', v.peso_mercancia] : null,
    ].filter(Boolean);
    if (mercDatos.length > 0) {
      doc.setFontSize(9); doc.setFont('helvetica', 'bold'); doc.setTextColor(0, 0, 0);
      doc.text('MERCANCIA', margin, y); y += 4;
      doc.setLineWidth(0.3); doc.setDrawColor(150, 150, 150);
      doc.line(margin, y, pageW - margin, y); y += 6;
      mercDatos.forEach(([label, val]) => {
        doc.setFont('helvetica', 'bold'); doc.setFontSize(8); doc.setTextColor(100, 100, 100);
        doc.text(label + ':', margin, y);
        doc.setFont('helvetica', 'normal'); doc.setFontSize(9); doc.setTextColor(0, 0, 0);
        const lines = doc.splitTextToSize(String(val), pageW - margin * 2 - 42);
        doc.text(lines, margin + 40, y);
        y += Math.max(6, lines.length * 4.5) + 2;
      });
      y += 6;
    }

    // Transporte
    const transDatos = [
      v.carrier ? ['Carrier', v.carrier] : null,
      v.conductor ? ['Conductor', v.conductor] : null,
      v.unidad ? ['Unidad', v.unidad] : null,
      v.placas ? ['Placas', v.placas] : null,
      v.caja ? ['Caja', v.caja] : null,
    ].filter(Boolean);
    if (transDatos.length > 0) {
      doc.setFontSize(9); doc.setFont('helvetica', 'bold'); doc.setTextColor(0, 0, 0);
      doc.text('TRANSPORTE', margin, y); y += 4;
      doc.setLineWidth(0.3); doc.setDrawColor(150, 150, 150);
      doc.line(margin, y, pageW - margin, y); y += 6;
      const cols = Math.min(transDatos.length, 3);
      const cw = (pageW - margin * 2) / cols;
      transDatos.forEach(([label, val], i) => {
        const cx = margin + (i % cols) * cw;
        const cy = y + Math.floor(i / cols) * 12;
        doc.setFont('helvetica', 'bold'); doc.setFontSize(8); doc.setTextColor(100, 100, 100);
        doc.text(label, cx, cy);
        doc.setFont('helvetica', 'normal'); doc.setFontSize(10); doc.setTextColor(0, 0, 0);
        doc.text(String(val), cx, cy + 5);
      });
      y += Math.ceil(transDatos.length / 3) * 12 + 10;
    }

    // Bitacora y gastos solo si completado
    if (v.estado === 'completed' && v.hitos?.length > 0) {
      doc.setLineWidth(0.3); doc.setDrawColor(180, 180, 180);
      doc.line(margin, y, pageW - margin, y); y += 8;
      doc.setFontSize(10); doc.setFont('helvetica', 'bold'); doc.setTextColor(0, 0, 0);
      doc.text('BITACORA DE HITOS', margin, y); y += 4;
      autoTable(doc, {
        startY: y,
        head: [['Fecha', 'Hora', 'Hito', 'Ubicacion']],
        body: v.hitos.map(h => [h.fecha || '--', h.hora || '--', h.nombre, h.ubicacion || '--']),
        styles: { fontSize: 8, cellPadding: 3 },
        headStyles: { fillColor: [50, 50, 50], textColor: [255, 255, 255], fontStyle: 'bold', fontSize: 8 },
        alternateRowStyles: { fillColor: [248, 248, 248] },
        columnStyles: { 0: { cellWidth: 24 }, 1: { cellWidth: 16 }, 2: { cellWidth: 55 } },
        margin: { left: margin, right: margin },
      });
      y = doc.lastAutoTable.finalY + 8;
    }

    if (v.estado === 'completed' && v.gastos?.length > 0) {
      const gastoTotal = v.gastos.reduce((a, g) => a + parseFloat(g.monto || 0), 0);
      doc.setFontSize(10); doc.setFont('helvetica', 'bold'); doc.setTextColor(0, 0, 0);
      doc.text('GASTOS DEL VIAJE', margin, y); y += 4;
      autoTable(doc, {
        startY: y,
        head: [['Descripcion', 'Categoria', 'Monto (MXN)']],
        body: v.gastos.map(g => [g.descripcion, g.categoria, `$${parseFloat(g.monto).toLocaleString('es-MX', { minimumFractionDigits: 2 })}`]),
        foot: [['', 'TOTAL', `$${gastoTotal.toLocaleString('es-MX', { minimumFractionDigits: 2 })}`]],
        styles: { fontSize: 8, cellPadding: 3 },
        headStyles: { fillColor: [50, 50, 50], textColor: [255, 255, 255], fontStyle: 'bold', fontSize: 8 },
        footStyles: { fillColor: [240, 240, 240], textColor: [0, 0, 0], fontStyle: 'bold' },
        alternateRowStyles: { fillColor: [248, 248, 248] },
        columnStyles: { 2: { halign: 'right' } },
        margin: { left: margin, right: margin },
      });
    }

    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.setFontSize(7); doc.setFont('helvetica', 'normal'); doc.setTextColor(150, 150, 150);
      doc.text(`${empresa?.nombre || 'LogiConnect'} · Pagina ${i} de ${pageCount}`, margin, 272);
    }

    doc.save(`carta_instrucciones_${v.numero}_${new Date().toLocaleDateString('es-MX').replace(/\//g, '-')}.pdf`);
  };
    
  const totalGastos = selected?.gastos?.reduce((a, g) => a + parseFloat(g.monto || 0), 0) || 0;
  const estadoUnidad = selected ? estadoUnidadDesdeHitos(selected.hitos, hitosConfig) : null;
  const tiemposEspera = selected ? calcularTiempoEspera(selected.hitos) : null;

  const camposEdicion = [
    { label: 'Numero de viaje', key: 'numero' }, { label: 'Numero de factura', key: 'factura' },
    { label: 'Conductor', key: 'conductor' }, { label: 'Salida', key: 'salida' },
    { label: 'Link GPS', key: 'linkGps' }, { label: 'Numero de unidad', key: 'unidad' },
    { label: 'Numero de caja', key: 'caja' }, { label: 'Placas', key: 'placas' },
    { label: 'Proveedor GPS', key: 'gps' },
    { label: 'Instrucciones especiales', key: 'instrucciones_especiales' },
    { label: 'Descripcion de mercancia', key: 'descripcion_mercancia' },
    { label: 'Peso / Volumen', key: 'peso_mercancia' },
  ];

  const inp = { background: '#181c24', border: '1px solid #222730', borderRadius: '6px', padding: '10px 12px', color: '#e8eaf0', fontSize: '13px' };
  const inpEdit = { width: '100%', background: '#181c24', border: '1px solid #00e5a0', borderRadius: '6px', padding: '8px 10px', color: '#e8eaf0', fontSize: '13px' };
  const inpSm = { background: '#181c24', border: '1px solid #00e5a0', borderRadius: '6px', padding: '4px 8px', color: '#e8eaf0', fontSize: '12px' };
  const lbl = { fontSize: '12px', color: '#9ca3af' };
  const lblEdit = { fontSize: '11px', color: '#6b7280', display: 'block', marginBottom: '4px' };

  return (
    <div style={{ display: 'flex', height: 'calc(100vh - 60px)' }}>
      {/* SIDEBAR */}
      <div style={{ width: '300px', background: '#111318', borderRight: '1px solid #222730', overflowY: 'auto', flexShrink: 0 }}>
        <div style={{ padding: '16px', borderBottom: '1px solid #222730', display: 'flex', alignItems: 'center', justifyContent: 'space-between', position: 'sticky', top: 0, background: '#111318' }}>
          <span style={{ fontSize: '13px', fontWeight: '600', color: '#ffffff' }}>Viajes ({viajesFiltrados.length})</span>
          <button onClick={() => { setShowNuevo(true); setSelected(null); setEditando(false); setErrorNumero(''); }}
            style={{ background: '#00e5a0', color: '#000', border: 'none', borderRadius: '6px', padding: '5px 10px', fontSize: '12px', fontWeight: '700', cursor: 'pointer' }}>+ Nuevo</button>
        </div>
        <div style={{ padding: '8px' }}>
          <input value={filtro} onChange={e => setFiltro(e.target.value)} placeholder="Filtrar por carrier, cliente, ruta..."
            style={{ width: '100%', background: '#181c24', border: '1px solid #222730', borderRadius: '6px', padding: '8px 10px', color: '#e8eaf0', fontSize: '12px', boxSizing: 'border-box' }} />
        </div>
        <div style={{ fontSize: '10px', color: '#6b7280', textTransform: 'uppercase', letterSpacing: '2px', padding: '4px 16px' }}>Activos</div>
        <div style={{ padding: '0 8px 8px' }}>
          {viajesFiltrados.map(v => {
            const eu = estadoUnidadDesdeHitos(v.hitos, hitosConfig);
            return (
              <div key={v.id} onClick={() => { setSelected(v); setShowNuevo(false); setEditando(false); setActiveTab('bitacora'); }}
                style={{ padding: '14px', borderRadius: '8px', marginBottom: '6px', cursor: 'pointer', border: `1px solid ${selected?.id === v.id ? '#00e5a0' : '#222730'}`, background: selected?.id === v.id ? 'rgba(0,229,160,0.06)' : '#181c24' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '6px' }}>
                  <span style={{ fontFamily: 'monospace', fontSize: '13px', fontWeight: '700', color: '#00e5a0' }}>{v.numero}</span>
                  <span style={{ fontSize: '10px', fontWeight: '600', padding: '2px 8px', borderRadius: '10px', background: `${estadoViaje[v.estado] || '#6b7280'}18`, color: estadoViaje[v.estado] || '#6b7280' }}>{labelViaje[v.estado] || v.estado}</span>
                </div>
                <div style={{ fontSize: '13px', fontWeight: '600', marginBottom: '2px', color: '#e8eaf0' }}>{v.ruta}</div>
                <div style={{ fontSize: '12px', color: '#9ca3af', marginBottom: '6px' }}>{v.carrier}{v.conductor ? ` · ${v.conductor}` : ''}</div>
                {v.usuario_nombre && <div style={{ fontSize: '11px', color: '#8b5cf6', marginBottom: '4px' }}>{v.usuario_nombre}</div>}
                {v.unidad && <div style={{ fontSize: '11px', color: '#6b7280', marginBottom: '4px' }}>{v.unidad}{v.caja ? ` · ${v.caja}` : ''}{v.placas ? ` · ${v.placas}` : ''}</div>}
                <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
                  <span style={{ fontSize: '10px', padding: '2px 8px', borderRadius: '10px', background: `${eu.color}18`, color: eu.color }}>{eu.label}</span>
                  {!v.linkGps && !v.link_gps && <span style={{ fontSize: '10px', color: '#f59e0b' }}>Sin GPS</span>}
                </div>
              </div>
            );
          })}
          {viajesFiltrados.length === 0 && <div style={{ padding: '32px', textAlign: 'center', color: '#6b7280', fontSize: '13px' }}>Sin viajes activos</div>}
        </div>
      </div>

      {/* CONTENIDO */}
      <div style={{ flex: 1, overflowY: 'auto', padding: '28px 32px' }}>
        {!selected && !showNuevo && (
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', flexDirection: 'column', gap: '16px' }}>
            <div style={{ fontSize: '16px', color: '#9ca3af' }}>Selecciona un viaje o crea uno nuevo</div>
          </div>
        )}

        {showNuevo && (
          <div>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '24px' }}>
              <h2 style={{ fontSize: '20px', fontWeight: '700', color: '#ffffff' }}>Nuevo Viaje</h2>
              <button onClick={() => setShowNuevo(false)} style={{ background: 'transparent', border: '1px solid #222730', color: '#9ca3af', borderRadius: '6px', padding: '6px 12px', fontSize: '12px', cursor: 'pointer' }}>Cancelar</button>
            </div>
            <div style={{ background: '#111318', border: '1px solid #222730', borderRadius: '10px', padding: '24px' }}>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                  <label style={lbl}>Ruta</label>
                  <select value={nuevoViaje.ruta} onChange={e => {
                    const rutaSeleccionada = listaRutas.find(r => {
                      const label = `${r.lugar_carga} \u2192 ${r.lugar_descarga}`;
                      return label === e.target.value;
                    });
                    setNuevoViaje({
                      ...nuevoViaje,
                      ruta: e.target.value,
                      direccion_origen: rutaSeleccionada?.direccion_carga || '',
                      direccion_destino: rutaSeleccionada?.direccion_descarga || '',
                    });
                  }} style={inp}>
                    <option value="">Seleccionar ruta...</option>
                    {listaRutas.map(r => {
                      const label = `${r.lugar_carga} \u2192 ${r.lugar_descarga}`;
                      return <option key={r.id} value={label}>{label}</option>;
                    })}
                  </select>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                  <label style={lbl}>Cliente</label>
                  <select value={nuevoViaje.cliente} onChange={e => setNuevoViaje({ ...nuevoViaje, cliente: e.target.value })} style={inp}>
                    <option value="">Seleccionar cliente...</option>
                    {listaClientes.map(c => <option key={c.id} value={c.nombre}>{c.nombre}</option>)}
                  </select>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                  <label style={lbl}>Carrier</label>
                  <select value={nuevoViaje.carrier} onChange={e => setNuevoViaje({ ...nuevoViaje, carrier: e.target.value })} style={inp}>
                    <option value="">Seleccionar carrier...</option>
                    {listaCarriers.map(c => <option key={c.id} value={c.nombre}>{c.nombre}</option>)}
                  </select>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                  <label style={lbl}>Ejecutivo asignado</label>
                  <select value={nuevoViaje.usuario_id} onChange={e => setNuevoViaje({ ...nuevoViaje, usuario_id: e.target.value })} style={inp}>
                    <option value="">Sin asignar</option>
                    {listaUsuarios.map(u => <option key={u.id} value={u.id}>{u.nombre}</option>)}
                  </select>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                  <label style={lbl}>Numero de viaje *</label>
                  <input value={nuevoViaje.numero} onChange={e => { setNuevoViaje({ ...nuevoViaje, numero: e.target.value }); setErrorNumero(''); }}
                    placeholder="V-003" style={{ ...inp, border: errorNumero ? '1px solid #ef4444' : '1px solid #222730' }} />
                  {errorNumero && <span style={{ fontSize: '11px', color: '#ef4444' }}>{errorNumero}</span>}
                </div>
                {[
                  { label: 'Numero de factura', key: 'factura', placeholder: 'FAC-2026-003' },
                  { label: 'Conductor', key: 'conductor', placeholder: 'Nombre del conductor' },
                  { label: 'Salida programada', key: 'salida', placeholder: '', tipo: 'datetime-local' },
                  { label: 'Proveedor GPS', key: 'gps', placeholder: 'Geotab, Samsara...' },
                  { label: 'Numero de unidad', key: 'unidad', placeholder: 'TRK-001' },
                  { label: 'Numero de caja', key: 'caja', placeholder: 'CJ-4521' },
                  { label: 'Placas', key: 'placas', placeholder: 'ABC-123-D' },
                  { label: 'Link GPS', key: 'linkGps', placeholder: 'https://share.geotab.com/...' },
                ].map(field => (
                  <div key={field.key} style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                    <label style={lbl}>{field.label}</label>
                    <input type={field.tipo || 'text'} value={nuevoViaje[field.key]} onChange={e => setNuevoViaje({ ...nuevoViaje, [field.key]: e.target.value })}
                      placeholder={field.placeholder} style={inp} />
                  </div>
                ))}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', gridColumn: '1 / -1' }}>
                  <label style={lbl}>Instrucciones especiales</label>
                  <textarea value={nuevoViaje.instrucciones_especiales} onChange={e => setNuevoViaje({ ...nuevoViaje, instrucciones_especiales: e.target.value })}
                    placeholder="Temperatura controlada, mercancia fragil, manejo especial..." rows={2}
                    style={{ ...inp, resize: 'vertical', fontFamily: 'inherit', width: '100%', boxSizing: 'border-box' }} />
                </div>
                
                <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                  <label style={lbl}>Descripcion de mercancia</label>
                  <input value={nuevoViaje.descripcion_mercancia} onChange={e => setNuevoViaje({ ...nuevoViaje, descripcion_mercancia: e.target.value })} placeholder="Tipo de mercancia" style={inp} />
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                  <label style={lbl}>Peso / Volumen</label>
                  <input value={nuevoViaje.peso_mercancia} onChange={e => setNuevoViaje({ ...nuevoViaje, peso_mercancia: e.target.value })} placeholder="Ej: 5 ton / 20 m3" style={inp} />
                </div>
              </div>
              <button onClick={handleCrearViaje} style={{ marginTop: '20px', background: '#00e5a0', color: '#000', border: 'none', borderRadius: '8px', padding: '12px 24px', fontSize: '14px', fontWeight: '700', cursor: 'pointer' }}>Crear Viaje</button>
            </div>
          </div>
        )}

        {selected && !showNuevo && (
          <div>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '24px' }}>
              <div>
                <span style={{ fontFamily: 'monospace', fontSize: '22px', fontWeight: '700', color: '#00e5a0' }}>{selected.numero}</span>
                <span style={{ fontSize: '14px', color: '#9ca3af', marginLeft: '12px' }}>{selected.ruta}</span>
                {estadoUnidad && <span style={{ fontSize: '12px', fontWeight: '600', padding: '3px 10px', borderRadius: '10px', background: `${estadoUnidad.color}18`, color: estadoUnidad.color, marginLeft: '10px' }}>{estadoUnidad.label}</span>}
              </div>
              <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                <span style={{ fontSize: '12px', fontWeight: '600', padding: '4px 12px', borderRadius: '10px', background: `${estadoViaje[selected.estado] || '#6b7280'}18`, color: estadoViaje[selected.estado] || '#6b7280' }}>{labelViaje[selected.estado] || selected.estado}</span>
                <button onClick={exportarViajePDF} style={{ background: 'transparent', border: '1px solid #222730', color: '#9ca3af', borderRadius: '6px', padding: '6px 12px', fontSize: '12px', cursor: 'pointer' }}>Carta de instrucciones</button>
                {!editando ? (
                  <>
                    
                    <button onClick={() => { setEditando(true); setEditData({ ...selected }); }} style={{ background: 'transparent', border: '1px solid #222730', color: '#9ca3af', borderRadius: '6px', padding: '6px 12px', fontSize: '12px', cursor: 'pointer' }}>Editar</button>
                  </>
                ) : (
                  <button onClick={guardarEdicion} style={{ background: '#00e5a0', color: '#000', border: 'none', borderRadius: '6px', padding: '6px 12px', fontSize: '12px', fontWeight: '700', cursor: 'pointer' }}>Guardar</button>
                )}
                <button onClick={() => setShowConfirmDelete(true)} style={{ background: 'rgba(239,68,68,0.1)', border: '1px solid rgba(239,68,68,0.3)', color: '#ef4444', borderRadius: '6px', padding: '6px 12px', fontSize: '12px', cursor: 'pointer' }}>Eliminar</button>
              </div>
            </div>

            {showAprobacion && hitoPendiente && (selected.linkGps || selected.link_gps) && (
              <div style={{ background: 'rgba(245,158,11,0.08)', border: '1px solid rgba(245,158,11,0.3)', borderRadius: '10px', padding: '20px', marginBottom: '20px' }}>
                <div style={{ fontSize: '14px', fontWeight: '600', color: '#f59e0b', marginBottom: '8px' }}>Aprobacion requerida — {hitoPendiente.hito.nombre}</div>
                <div style={{ fontSize: '12px', color: '#9ca3af', marginBottom: '12px' }}>Este hito requiere aprobacion manual antes de notificar al cliente.</div>
                <div style={{ display: 'flex', gap: '8px' }}>
                  <button onClick={async () => {
                    const hito = { ...hitoPendiente.hito, aprobado: true, notificado: true };
                    await crearHito(hito);
                    let nuevoEstado = selected.estado;
                    if (hitoPendiente.hito.nombre === 'Completado') { nuevoEstado = 'completed'; await actualizarViaje(selected.id, { estado: 'completed', fecha_cierre: new Date().toISOString() }); }
                    const updated = viajes.map(v => v.id === selected.id ? { ...v, hitos: [...v.hitos, hito], estado: nuevoEstado } : v);
                    setViajes(updated); setSelected({ ...selected, hitos: [...selected.hitos, hito], estado: nuevoEstado });
                    setShowAprobacion(false); setHitoPendiente(null);
                   const clienteWA = listaClientes.find(c => c.nombre === selected.cliente);
                   const plantillaWA = plantillas.find(p => p.descripcion === hitoPendiente.hito.nombre);
                    if (plantillaWA && clienteWA?.whatsapp) {
                    const msg = (plantillaWA.texto || '')
                    .replace('{conductor}', selected.conductor || '')
                    .replace('{unidad}', selected.unidad || '')
                    .replace('{ruta}', selected.ruta || '')
                    .replace('{ubicacion}', hitoPendiente.hito.ubicacion || '')
                    .replace('{eta}', hitoPendiente.hito.eta || '')
                    .replace('{cliente}', selected.cliente || '')
                    .replace('{placas}', selected.placas || '');
                  const numero = clienteWA.whatsapp.replace(/\D/g, '');
                  window.open(`https://wa.me/${numero}?text=${encodeURIComponent(msg)}`, '_blank');
                  }
                 }} style={{ background: '#00e5a0', color: '#000', border: 'none', borderRadius: '6px', padding: '8px 16px', fontSize: '13px', fontWeight: '700', cursor: 'pointer' }}>Aprobar y enviar</button>
                  <button onClick={async () => {
                    const hito = { ...hitoPendiente.hito, aprobado: false, notificado: false };
                    await crearHito(hito);
                    let nuevoEstadoRSN = selected.estado;
                    if (hitoPendiente.hito.nombre === 'Completado') { nuevoEstadoRSN = 'completed'; await actualizarViaje(selected.id, { estado: 'completed', fecha_cierre: new Date().toISOString() }); }
                    const updated = viajes.map(v => v.id === selected.id ? { ...v, hitos: [...v.hitos, hito], estado: nuevoEstadoRSN } : v);
                    setViajes(updated); setSelected({ ...selected, hitos: [...selected.hitos, hito], estado: nuevoEstadoRSN });
                    setShowAprobacion(false); setHitoPendiente(null);
                  }} style={{ background: 'transparent', border: '1px solid #222730', color: '#9ca3af', borderRadius: '6px', padding: '8px 16px', fontSize: '13px', cursor: 'pointer' }}>Registrar sin notificar</button>
                  <button onClick={() => { setShowAprobacion(false); setHitoPendiente(null); }}
                    style={{ background: 'rgba(239,68,68,0.1)', border: '1px solid rgba(239,68,68,0.3)', color: '#ef4444', borderRadius: '6px', padding: '8px 16px', fontSize: '13px', cursor: 'pointer' }}>Descartar</button>
                </div>
              </div>
            )}

            {showConfirmDelete && (
              <div style={{ background: 'rgba(239,68,68,0.08)', border: '1px solid rgba(239,68,68,0.3)', borderRadius: '10px', padding: '16px 20px', marginBottom: '20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <span style={{ fontSize: '13px', color: '#e8eaf0' }}>Eliminar viaje <strong style={{ color: '#ef4444' }}>{selected.numero}</strong>? Esta accion no se puede deshacer.</span>
                <div style={{ display: 'flex', gap: '8px' }}>
                  <button onClick={handleEliminarViaje} style={{ background: '#ef4444', color: '#fff', border: 'none', borderRadius: '6px', padding: '6px 14px', fontSize: '12px', fontWeight: '700', cursor: 'pointer' }}>Confirmar</button>
                  <button onClick={() => setShowConfirmDelete(false)} style={{ background: 'transparent', border: '1px solid #222730', color: '#9ca3af', borderRadius: '6px', padding: '6px 14px', fontSize: '12px', cursor: 'pointer' }}>Cancelar</button>
                </div>
              </div>
            )}

            {!selected.linkGps && !selected.link_gps && !editando && (
              <div style={{ background: 'rgba(245,158,11,0.08)', border: '1px solid rgba(245,158,11,0.3)', borderRadius: '10px', padding: '12px 20px', marginBottom: '16px' }}>
                <div style={{ fontSize: '13px', fontWeight: '600', color: '#f59e0b' }}>Sin link GPS enlazado</div>
                <div style={{ fontSize: '12px', color: '#9ca3af' }}>Haz clic en Editar para agregar el link GPS.</div>
              </div>
            )}

            <div style={{ background: '#111318', border: '1px solid #222730', borderRadius: '10px', padding: '24px', marginBottom: '20px' }}>
              <div style={{ fontSize: '13px', fontWeight: '600', color: '#6b7280', textTransform: 'uppercase', letterSpacing: '2px', marginBottom: '16px' }}>Ficha del Viaje</div>
              {editando ? (
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '14px' }}>
                  <div><label style={lblEdit}>Carrier</label>
                    <select value={editData.carrier || ''} onChange={e => setEditData({ ...editData, carrier: e.target.value })} style={inpEdit}>
                      <option value="">Seleccionar carrier...</option>
                      {listaCarriers.map(c => <option key={c.id} value={c.nombre}>{c.nombre}</option>)}
                    </select>
                  </div>
                  <div><label style={lblEdit}>Cliente</label>
                    <select value={editData.cliente || ''} onChange={e => setEditData({ ...editData, cliente: e.target.value })} style={inpEdit}>
                      <option value="">Seleccionar cliente...</option>
                      {listaClientes.map(c => <option key={c.id} value={c.nombre}>{c.nombre}</option>)}
                    </select>
                  </div>
                  <div><label style={lblEdit}>Ejecutivo asignado</label>
                    <select value={editData.usuario_id || ''} onChange={e => setEditData({ ...editData, usuario_id: e.target.value })} style={inpEdit}>
                      <option value="">Sin asignar</option>
                      {listaUsuarios.map(u => <option key={u.id} value={u.id}>{u.nombre}</option>)}
                    </select>
                  </div>
                  <div><label style={lblEdit}>Ruta</label>
                    <select value={editData.ruta || ''} onChange={e => setEditData({ ...editData, ruta: e.target.value })} style={inpEdit}>
                      <option value="">Seleccionar ruta...</option>
                      {listaRutas.map(r => {
                        const label = `${r.lugar_carga} \u2192 ${r.lugar_descarga}`;
                        return <option key={r.id} value={label}>{label}</option>;
                      })}
                    </select>
                  </div>
                  {camposEdicion.map(f => (
                    <div key={f.key}><label style={lblEdit}>{f.label}</label>
                      <input value={editData[f.key] || ''} onChange={e => setEditData({ ...editData, [f.key]: e.target.value })} style={inpEdit} />
                    </div>
                  ))}
                </div>
              ) : (
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '16px' }}>
                  {[
                    { label: 'Numero de viaje', value: selected.numero },
                    { label: 'Numero de factura', value: selected.factura || '--' },
                    { label: 'Carrier', value: selected.carrier || '--' },
                    { label: 'Conductor', value: selected.conductor || '--' },
                    { label: 'Cliente', value: selected.cliente || '--' },
                    { label: 'Ejecutivo asignado', value: selected.usuario_nombre || '--' },
                    { label: 'Ruta', value: selected.ruta || '--' },
                    { label: 'Unidad', value: selected.unidad || '--' },
                    { label: 'Numero de caja', value: selected.caja || '--' },
                    { label: 'Placas', value: selected.placas || '--' },
                    { label: 'Proveedor GPS', value: selected.gps || '--' },
                    selected.instrucciones_especiales ? { label: 'Instrucciones especiales', value: selected.instrucciones_especiales } : null,
                    selected.direccion_origen ? { label: 'Origen', value: selected.direccion_origen } : null,
                    selected.direccion_destino ? { label: 'Destino', value: selected.direccion_destino } : null,
                    selected.contacto_origen ? { label: 'Contacto origen', value: selected.contacto_origen } : null,
                    selected.contacto_destino ? { label: 'Contacto destino', value: selected.contacto_destino } : null,
                    selected.descripcion_mercancia ? { label: 'Mercancia', value: selected.descripcion_mercancia } : null,
                    selected.peso_mercancia ? { label: 'Peso / Volumen', value: selected.peso_mercancia } : null,
                    (selected.linkGps || selected.link_gps) ? { label: 'Link GPS', value: '__GPS_LINK__' } : { label: 'Link GPS', value: 'Sin GPS' },
                  ].filter(Boolean).map(item => (
                    <div key={item.label}>
                      <div style={{ fontSize: '11px', color: '#6b7280', marginBottom: '4px' }}>{item.label}</div>
                      <div style={{ fontSize: '14px', fontWeight: '500', color: item.label === 'Ejecutivo asignado' ? '#8b5cf6' : '#e8eaf0' }}>
  {item.value === '__GPS_LINK__'
    ? <a href={selected.linkGps || selected.link_gps} target="_blank" rel="noreferrer" style={{ color: '#3b82f6', textDecoration: 'none', fontWeight: '600' }}>🔗 Ver ubicación</a>
    : item.value}
</div>
                    </div>
                  ))}
                </div>
              )}
            </div>

            {tiemposEspera && tiemposEspera.length > 0 && (
              <div style={{ background: '#111318', border: '1px solid #222730', borderRadius: '10px', padding: '20px', marginBottom: '20px' }}>
                <div style={{ fontSize: '13px', fontWeight: '600', color: '#6b7280', textTransform: 'uppercase', letterSpacing: '2px', marginBottom: '12px' }}>Tiempos de Espera</div>
                <div style={{ display: 'flex', gap: '24px' }}>
                  {tiemposEspera.map((t, i) => (
                    <div key={i}>
                      <div style={{ fontSize: '11px', color: '#6b7280', marginBottom: '4px' }}>{t.label}</div>
                      <div style={{ fontSize: '20px', fontWeight: '700', color: '#f35ff1' }}>{t.valor}</div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            <div style={{ display: 'flex', gap: '4px', marginBottom: '20px', borderBottom: '1px solid #222730' }}>
              {[{ id: 'bitacora', label: 'Bitacora' }, { id: 'gastos', label: 'Gastos' }].map(tab => (
                <div key={tab.id} onClick={() => setActiveTab(tab.id)}
                  style={{ padding: '10px 20px', cursor: 'pointer', fontSize: '13px', fontWeight: '500', color: activeTab === tab.id ? '#00e5a0' : '#6b7280', borderBottom: `2px solid ${activeTab === tab.id ? '#00e5a0' : 'transparent'}`, marginBottom: '-1px' }}>
                  {tab.label}
                </div>
              ))}
            </div>

            {activeTab === 'bitacora' && (
              <div style={{ background: '#111318', border: '1px solid #222730', borderRadius: '10px', overflow: 'hidden', marginBottom: '16px' }}>
                <div style={{ padding: '14px 20px', borderBottom: '1px solid #222730', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span style={{ fontSize: '13px', fontWeight: '600', color: '#ffffff' }}>
                    Hitos Confirmados
                    {selected.estado === 'completed' && <span style={{ fontSize: '11px', color: '#6b7280', fontWeight: '400', marginLeft: '8px' }}>— edicion sin notificacion</span>}
                  </span>
                  <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                    <span style={{ fontSize: '11px', color: '#6b7280' }}>{selected.hitos?.length || 0} registrados</span>
                    <button onClick={() => setShowNuevoHito(true)} style={{ background: 'rgba(0,229,160,0.1)', border: '1px solid rgba(0,229,160,0.2)', color: '#00e5a0', borderRadius: '6px', padding: '4px 10px', fontSize: '11px', cursor: 'pointer', fontWeight: '600' }}>+ Agregar</button>
                  </div>
                </div>
                {showNuevoHito && (
                  <div style={{ padding: '12px 20px', borderBottom: '1px solid #222730', background: 'rgba(0,229,160,0.03)', display: 'flex', gap: '8px' }}>
                    <select value={nuevoHito} onChange={e => setNuevoHito(e.target.value)}
                      style={{ flex: 1, background: '#181c24', border: '1px solid #222730', borderRadius: '6px', padding: '8px 12px', color: '#e8eaf0', fontSize: '13px' }}>
                      <option value="">Seleccionar hito...</option>
                      {(hitosConfig ? hitosConfig.filter(h => h.activo).map(h => h.nombre) : hitosDefault).map(h => <option key={h} value={h}>{h}</option>)}
                    </select>
<button onClick={agregarHito} style={{ background: '#00e5a0', color: '#000', border: 'none', borderRadius: '6px', padding: '8px 14px', fontSize: '12px', fontWeight: '700', cursor: 'pointer' }}>Agregar</button>
{nuevoHito && nuevoHito !== 'Completado' && (
  <input value={hitoUbicacion} onChange={e => setHitoUbicacion(e.target.value)}
    placeholder="Ubicacion actual" style={{ background: '#181c24', border: '1px solid #222730', borderRadius: '6px', padding: '8px 10px', color: '#e8eaf0', fontSize: '12px', flex: 1 }} />
)}
{nuevoHito && nuevoHito !== 'Completado' && (
  <input value={hitoEta} onChange={e => setHitoEta(e.target.value)}
    placeholder="ETA (ej: 6 horas)" style={{ background: '#181c24', border: '1px solid #222730', borderRadius: '6px', padding: '8px 10px', color: '#e8eaf0', fontSize: '12px', width: '120px' }} />
)}
<button onClick={() => setShowNuevoHito(false)} style={{ background: 'transparent', border: '1px solid #222730', color: '#9ca3af', borderRadius: '6px', padding: '8px 14px', fontSize: '12px', cursor: 'pointer' }}>Cancelar</button>                  </div>
                )}
                {ultimoHitoWA && (
  <div style={{ padding: '12px 20px', borderBottom: '1px solid #222730', background: 'rgba(37,211,102,0.05)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
    <span style={{ fontSize: '13px', color: '#25d366' }}>Hito registrado — ¿Notificar al cliente por WhatsApp?</span>
    <div style={{ display: 'flex', gap: '8px' }}>
      <button onClick={() => {
        const msg = (ultimoHitoWA.plantilla.texto || '')
          .replace('{conductor}', selected.conductor || '')
          .replace('{unidad}', selected.unidad || '')
          .replace('{ruta}', selected.ruta || '')
          .replace('{ubicacion}', ultimoHitoWA.ubicacion || '')
          .replace('{eta}', ultimoHitoWA.eta || '')
          .replace('{cliente}', selected.cliente || '')
          .replace('{placas}', selected.placas || '');
        const numero = ultimoHitoWA.cliente.whatsapp.replace(/\D/g, '');
        window.open(`https://wa.me/${numero}?text=${encodeURIComponent(msg)}`, '_blank');
        setUltimoHitoWA(null);
      }} style={{ background: '#25d366', color: '#fff', border: 'none', borderRadius: '6px', padding: '6px 14px', fontSize: '12px', fontWeight: '700', cursor: 'pointer' }}>Enviar WhatsApp</button>
      <button onClick={() => setUltimoHitoWA(null)} style={{ background: 'transparent', border: '1px solid #222730', color: '#9ca3af', borderRadius: '6px', padding: '6px 14px', fontSize: '12px', cursor: 'pointer' }}>Omitir</button>
    </div>
  </div>
)}
                {(!selected.hitos || selected.hitos.length === 0) && !showNuevoHito && (
                  <div style={{ padding: '32px', textAlign: 'center', color: '#6b7280', fontSize: '13px' }}>Sin hitos registrados</div>
                )}
                {(selected.hitos || []).map((h, i) => {
                  const estadoHito = estadoUnidadDesdeHitos([h], hitosConfig);
                  const editandoEste = editandoHito === i;
                  return (
                    <div key={i} style={{ padding: '16px 20px', borderBottom: '1px solid #222730', display: 'flex', gap: '16px', alignItems: 'flex-start' }}>
                      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px' }}>
                        <div style={{ width: '32px', height: '32px', borderRadius: '50%', background: `${estadoHito.color}18`, border: `1px solid ${estadoHito.color}`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px', flexShrink: 0, color: estadoHito.color }}>✓</div>
                        {i < (selected.hitos?.length || 0) - 1 && <div style={{ width: '1px', height: '16px', background: '#222730' }}></div>}
                      </div>
                      <div style={{ flex: 1 }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px', alignItems: 'center' }}>
                          <span style={{ fontSize: '14px', fontWeight: '600', color: '#e8eaf0' }}>{h.nombre}</span>
                          {editandoEste ? (
                            <div style={{ display: 'flex', gap: '6px' }}>
                              <input type="date" value={editHitoData.fecha ?? new Date().toISOString().split('T')[0]} onChange={e => setEditHitoData({ ...editHitoData, fecha: e.target.value })}
                                style={{ ...inpSm, width: '140px', colorScheme: 'dark' }} />
                              <input type="time" value={editHitoData.hora ?? h.hora ?? ''} onChange={e => setEditHitoData({ ...editHitoData, hora: e.target.value })}
                                style={{ ...inpSm, width: '110px', colorScheme: 'dark' }} />
                            </div>
                          ) : (
                            <span style={{ fontSize: '11px', color: '#6b7280', fontFamily: 'monospace' }}>{h.fecha ? `${h.fecha} · ${h.hora}` : h.hora}</span>
                          )}
                        </div>
                        {editandoEste ? (
                          <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', marginTop: '8px' }}>
                            <input value={editHitoData.ubicacion ?? h.ubicacion ?? ''} onChange={e => setEditHitoData({ ...editHitoData, ubicacion: e.target.value })}
                              placeholder="Ubicacion" style={{ ...inpSm, width: '100%' }} />
                            <input value={editHitoData.comentario ?? h.comentario ?? ''} onChange={e => setEditHitoData({ ...editHitoData, comentario: e.target.value })}
                              placeholder="Comentario" style={{ ...inpSm, width: '100%' }} />
                            <div style={{ display: 'flex', gap: '8px', marginTop: '4px' }}>
                              <button onClick={() => guardarEdicionHito(i)} style={{ background: '#00e5a0', color: '#000', border: 'none', borderRadius: '6px', padding: '5px 12px', fontSize: '12px', fontWeight: '700', cursor: 'pointer' }}>Guardar</button>
                              <button onClick={() => { setEditandoHito(null); setEditHitoData({}); }} style={{ background: 'transparent', border: '1px solid #222730', color: '#9ca3af', borderRadius: '6px', padding: '5px 10px', fontSize: '12px', cursor: 'pointer' }}>Cancelar</button>
                            </div>
                          </div>
                        ) : (
                          <>
                            <div style={{ marginBottom: '4px' }}>
                              <span style={{ fontSize: '10px', padding: '2px 8px', borderRadius: '10px', background: `${estadoHito.color}18`, color: estadoHito.color }}>{estadoHito.label}</span>
                            </div>
                            {h.ubicacion && <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '4px' }}>{h.ubicacion}</div>}
                            {h.comentario && <div style={{ fontSize: '12px', color: '#9ca3af' }}>{h.comentario}</div>}
                            <div style={{ display: 'flex', gap: '8px', marginTop: '6px' }}>
                              {h.aprobado && <span style={{ fontSize: '10px', padding: '2px 8px', borderRadius: '10px', background: 'rgba(0,229,160,0.1)', color: '#00e5a0' }}>Aprobado</span>}
                              {h.notificado && <span style={{ fontSize: '10px', padding: '2px 8px', borderRadius: '10px', background: 'rgba(59,130,246,0.1)', color: '#3b82f6' }}>Cliente notificado</span>}
                            </div>
                          </>
                        )}
                      </div>
                      {!editandoEste && (
                        <div style={{ display: 'flex', gap: '4px', flexShrink: 0 }}>
                          <button onClick={() => { setEditandoHito(i); setEditHitoData({}); }} style={{ background: 'transparent', border: '1px solid #222730', color: '#9ca3af', borderRadius: '6px', padding: '4px 8px', fontSize: '11px', cursor: 'pointer' }}>Editar</button>
                          <button onClick={() => eliminarHito(i)} style={{ background: 'transparent', border: 'none', color: '#ef4444', cursor: 'pointer', fontSize: '14px', padding: '4px' }}>✕</button>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            )}

            {activeTab === 'gastos' && (
              <div style={{ background: '#111318', border: '1px solid #222730', borderRadius: '10px', overflow: 'hidden' }}>
                <div style={{ padding: '14px 20px', borderBottom: '1px solid #222730', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span style={{ fontSize: '13px', fontWeight: '600', color: '#ffffff' }}>Gastos del Viaje</span>
                  <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                    <span style={{ fontSize: '13px', color: '#00e5a0', fontWeight: '700' }}>Total: ${totalGastos.toLocaleString('es-MX', { minimumFractionDigits: 2 })} MXN</span>
                    <button onClick={() => setShowNuevoGasto(true)} style={{ background: 'rgba(0,229,160,0.1)', border: '1px solid rgba(0,229,160,0.2)', color: '#00e5a0', borderRadius: '6px', padding: '4px 10px', fontSize: '11px', cursor: 'pointer', fontWeight: '600' }}>+ Agregar gasto</button>
                  </div>
                </div>
                {showNuevoGasto && (
                  <div style={{ padding: '16px 20px', borderBottom: '1px solid #222730', background: 'rgba(0,229,160,0.03)' }}>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '12px', marginBottom: '12px' }}>
                      <div>
                        <label style={{ fontSize: '11px', color: '#9ca3af', display: 'block', marginBottom: '4px' }}>Descripcion</label>
                        <input value={nuevoGasto.descripcion} onChange={e => setNuevoGasto({ ...nuevoGasto, descripcion: e.target.value })}
                          placeholder="Ej: Carga de diesel" style={{ width: '100%', background: '#181c24', border: '1px solid #222730', borderRadius: '6px', padding: '8px 10px', color: '#e8eaf0', fontSize: '13px', boxSizing: 'border-box' }} />
                      </div>
                      <div>
                        <label style={{ fontSize: '11px', color: '#9ca3af', display: 'block', marginBottom: '4px' }}>Monto (MXN)</label>
                        <input type="number" value={nuevoGasto.monto} onChange={e => setNuevoGasto({ ...nuevoGasto, monto: e.target.value })}
                          placeholder="0.00" style={{ width: '100%', background: '#181c24', border: '1px solid #222730', borderRadius: '6px', padding: '8px 10px', color: '#e8eaf0', fontSize: '13px', boxSizing: 'border-box' }} />
                      </div>
                      <div>
                        <label style={{ fontSize: '11px', color: '#9ca3af', display: 'block', marginBottom: '4px' }}>Categoria</label>
                        <select value={nuevoGasto.categoria} onChange={e => setNuevoGasto({ ...nuevoGasto, categoria: e.target.value })}
                          style={{ width: '100%', background: '#181c24', border: '1px solid #222730', borderRadius: '6px', padding: '8px 10px', color: '#e8eaf0', fontSize: '13px', boxSizing: 'border-box' }}>
                          {categoriasGasto.map(c => <option key={c} value={c}>{c}</option>)}
                        </select>
                      </div>
                    </div>
                    <div style={{ marginBottom: '12px' }}>
                      <label style={{ fontSize: '11px', color: '#9ca3af', display: 'block', marginBottom: '4px' }}>Comentario</label>
                      <input value={nuevoGasto.comentario} onChange={e => setNuevoGasto({ ...nuevoGasto, comentario: e.target.value })}
                        placeholder="Notas adicionales..." style={{ width: '100%', background: '#181c24', border: '1px solid #222730', borderRadius: '6px', padding: '8px 10px', color: '#e8eaf0', fontSize: '13px', boxSizing: 'border-box' }} />
                    </div>
                    <div style={{ display: 'flex', gap: '8px' }}>
                      <button onClick={agregarGasto} style={{ background: '#00e5a0', color: '#000', border: 'none', borderRadius: '6px', padding: '8px 16px', fontSize: '13px', fontWeight: '700', cursor: 'pointer' }}>Guardar gasto</button>
                      <button onClick={() => setShowNuevoGasto(false)} style={{ background: 'transparent', border: '1px solid #222730', color: '#9ca3af', borderRadius: '6px', padding: '8px 16px', fontSize: '13px', cursor: 'pointer' }}>Cancelar</button>
                    </div>
                  </div>
                )}
                {(!selected.gastos || selected.gastos.length === 0) && !showNuevoGasto && (
                  <div style={{ padding: '32px', textAlign: 'center', color: '#6b7280', fontSize: '13px' }}>Sin gastos registrados</div>
                )}
                {(selected.gastos || []).map(g => (
                  <div key={g.id} style={{ padding: '14px 20px', borderBottom: '1px solid #222730', display: 'flex', alignItems: 'center', gap: '16px' }}>
                    <div style={{ flex: 1 }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '2px' }}>
                        <span style={{ fontSize: '13px', fontWeight: '600', color: '#e8eaf0' }}>{g.descripcion}</span>
                        <span style={{ fontSize: '14px', fontWeight: '700', color: '#00e5a0' }}>${parseFloat(g.monto).toLocaleString('es-MX', { minimumFractionDigits: 2 })} MXN</span>
                      </div>
                      <div style={{ display: 'flex', gap: '10px' }}>
                        <span style={{ fontSize: '11px', color: '#6b7280' }}>{g.categoria}</span>
                        {g.comentario && <span style={{ fontSize: '11px', color: '#6b7280' }}>· {g.comentario}</span>}
                        <span style={{ fontSize: '11px', color: '#6b7280' }}>· {g.fecha}</span>
                      </div>
                    </div>
                    <button onClick={() => eliminarGasto(g.id)} style={{ background: 'transparent', border: 'none', color: '#ef4444', cursor: 'pointer', fontSize: '14px' }}>✕</button>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
